import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-activity-type',
  templateUrl: './activity-type.component.html',
  styleUrls: ['./activity-type.component.css']
})
export class ActivityTypeComponent implements OnInit {
    public activityTypeNo: string;

    public activityTypeNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'activitytypelangs', gotoParms: () => this.edit!.activitytype_no ?? '' }];

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.activityTypeNo = this.stateService.getStateParams()['activitytype_no'];
    }

    private async loadEdit() {
        if (!!this.activityTypeNo) {
            this.edit = (await this.datatask.Post(401, { activitytype_no: this.activityTypeNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(402, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(403, { activitytype_no: this.edit.activitytype_no });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    activitytype_no: string;
    activitytype_name: string;
    only_activityplan: string;
    privat: string;
    onweb: string;
    show_solution_proposal: string;
    show_solution_note: string;
    show_prod_id: string;
    show_cust_no: string;
    show_project_keyno: string;
    show_projectprosess_keyno: string;
    show_actstatus_keyno: string;
    show_equipment_id: string;
    workorder: string;
    show_solution_note_preventive: string;
    show_datetime_start: string;
    show_datetime_end: string;
    show_responsible_user_id: string;
    show_responsible_labour_no: string;
    show_starttime_in_custact_relationlist: string;
    is_activitytype_no_deviation: string;
    is_activitytype_no_consignmentplan: string;
    is_activitytype_no_consignmentassembly: string;
    is_activitytype_no_voapproval: string;
    show_actstatus_in_custact_relationlist: string;
    is_jobcalc: string;
    show_deadline: string;
    show_next_activity: string;
    is_sales_opportunity: string;
    show_salarytype: string;
    show_in_gantt: string;
    show_guard: string;
    show_serviceobject_keyno: string;
    activitytype_prefix: string;
    confidential: string;
    customer_invoice: string;
    show_order_order_no: string;
    show_custactproducts: string;
    show_video_url: string;
    sync_with_microsoft_365: string;
}
